var render, staticRenderFns
import script from "./BaseComponent.vue?vue&type=script&lang=ts"
export * from "./BaseComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/assets/i18n/ja_JP.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3202800114%2Fsrc%2Fgithub.com%2Fmonet-technologies-com%2Fstore-front%2Fsrc%2Fcomponents%2FBaseComponent.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports